<template>
    <svg :width="size" :height="size + 2" :viewBox="`0 0 ${size} ${size + 2}`" fill="none" xmlns="http://www.w3.org/2000/svg" class="hourglass">
        <path
            d="M0 13.5C0 13.6326 0.0526785 13.7598 0.146447 13.8536C0.240215 13.9473 0.367392 14 0.5 14H11.5C11.6326 14 11.7598 13.9473 11.8536 13.8536C11.9473 13.7598 12 13.6326 12 13.5C12 13.3674 11.9473 13.2402 11.8536 13.1464C11.7598 13.0527 11.6326 13 11.5 13H10.5V12C10.5002 11.151 10.2602 10.3192 9.80775 9.60078C9.35529 8.88236 8.70881 8.30659 7.943 7.94C7.653 7.801 7.5 7.563 7.5 7.35V6.65C7.5 6.437 7.654 6.199 7.943 6.06C8.70881 5.69341 9.35529 5.11764 9.80775 4.39922C10.2602 3.6808 10.5002 2.84903 10.5 2V1H11.5C11.6326 1 11.7598 0.947322 11.8536 0.853553C11.9473 0.759785 12 0.632608 12 0.5C12 0.367392 11.9473 0.240215 11.8536 0.146447C11.7598 0.0526784 11.6326 0 11.5 0H0.5C0.367392 0 0.240215 0.0526784 0.146447 0.146447C0.0526785 0.240215 0 0.367392 0 0.5C0 0.632608 0.0526785 0.759785 0.146447 0.853553C0.240215 0.947322 0.367392 1 0.5 1H1.5V2C1.49979 2.84903 1.73979 3.6808 2.19225 4.39922C2.64471 5.11764 3.29119 5.69341 4.057 6.06C4.347 6.199 4.5 6.437 4.5 6.65V7.35C4.5 7.563 4.346 7.801 4.057 7.94C3.29119 8.30659 2.64471 8.88236 2.19225 9.60078C1.73979 10.3192 1.49979 11.151 1.5 12V13H0.5C0.367392 13 0.240215 13.0527 0.146447 13.1464C0.0526785 13.2402 0 13.3674 0 13.5ZM2.5 13V12C2.49982 11.3396 2.68649 10.6926 3.03845 10.1338C3.39041 9.57495 3.89329 9.12711 4.489 8.842C5.022 8.586 5.5 8.052 5.5 7.351V6.649C5.5 6.649 5.68 6.75 6 6.75C6.32 6.75 6.5 6.65 6.5 6.65V7.35C6.5 8.051 6.978 8.586 7.511 8.842C8.1067 9.12711 8.60959 9.57495 8.96155 10.1338C9.31351 10.6926 9.50018 11.3396 9.5 12V13H2.5Z"
            :fill="color" />
    </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B6C3D2',
    },
    hoverColor: {
      type: String,
      default: '#5F33FF',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>

<style scoped>
.hourglass:hover path {
    fill: v-bind(hoverColor);
}
</style>